module.exports = __webpack_public_path__ + "fonts/mc.a8dc4fc.eot";